import { useQuery } from '@tanstack/react-query';
import { fetchEquipmentTimeline } from '@apis/equipment';

/**
 * Today's movement timeline (and today's chart bar) for one asset — one
 * daily-route call, fetched apart from the past days so it never waits on them.
 * staleTime 1 min — today's route keeps growing while the panel is open.
 */
export function useEquipmentTimeline(siteId: string | null, equipmentId: string | null) {
  return useQuery({
    queryKey: ['equipment', 'timeline', siteId, equipmentId],
    queryFn: ({ signal }) => fetchEquipmentTimeline(siteId!, equipmentId!, signal),
    enabled: !!siteId && !!equipmentId,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
    // A route that just timed out upstream won't answer on a retry — fail fast to "unavailable".
    retry: false,
  });
}
